import { NgStyle } from '@angular/common';
import { Component, Input, Renderer2, SimpleChange, inject, DOCUMENT } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { IUser } from 'src/app/shared/model/user.model';
import { UtilService, VariablesService } from 'src/app/shared/services';

@Component({
    selector: 'app-profile-progress',
    imports: [
    NgStyle,
    MatIconModule
],
    templateUrl: './profile-progress.component.html',
    styleUrls: ['./profile-progress.component.scss']
})
export class ProfileProgressComponent {
  private renderer = inject(Renderer2);
  private document = inject<Document>(DOCUMENT);
  private util = inject(UtilService);
  private vars = inject(VariablesService);

  dashArray: number = 2 * Math.PI * 60;
  dashOffset: number =  this.dashArray;  // Initialize the offset to full circumference
  animationStyle: any = {'stroke-dashoffset': this.dashOffset};
  @Input() percentage: any = 50;
  userData: IUser | undefined;
  staticCircleCompleteValues: any = {
    100: 120,
    70: 200,
    55: 300,
    60: 205,
    30: 422
  }

  initials = '';

  ngOnInit() {
    this.setProfileProgressBar();
    if (this.userData) {
      this.initials = this.util.getInitialsOfName(this.userData?.full_name || '').toUpperCase();
    }
    this.getUserData();
  }

  getUserData() {
    this.vars.userData$.subscribe((val: any) => {
      this.userData = val;
    })
  }

  ngOnChanges(changes: any) {
    if (changes.percentage.currentValue) {
      this.setProfileProgressBar();
      this.getUserData();
    }
  }

  setProfileProgressBar() {
    if (this.percentage) {
      let finalOffset = this.dashArray * (1 - this.percentage / 100);
      if (this.percentage in this.staticCircleCompleteValues) {
        finalOffset = this.staticCircleCompleteValues[this.percentage];
      }
      if (typeof document !== 'undefined') {
        setTimeout(() => {
          this.dashOffset = finalOffset;
          this.addCustomAnimation(finalOffset);
        }, 0);
      }
    }
  }

  
  addCustomAnimation(offset: number) {
    const duration = '1s';  // You can change this to adjust the speed of the animation
    const easing = 'ease-in-out';  // Adjust the easing function if needed

    // Dynamically set the animation style string
    this.animationStyle = `anim ${duration} ${easing} forwards`;
    const styleSheet = this.renderer.createElement('style');
    styleSheet.type = 'text/css';
    const keyframes = `
      @keyframes anim {
        100% {
          stroke-dashoffset: ${offset};
        }
      }
    `;
    styleSheet.innerHTML = keyframes;
    this.renderer.appendChild(this.document.head, styleSheet);
  }
}
